export const metagenome_rows = [
  'Workflow activity: Read quality control',
  ['Filtered  sequencing reads', 'Quality filtered fastq.gz files', 'qc.fastq.zip'],
  [
    'Filtered  sequencing reads statistics',
    'Filtered  sequencing reads summary statistics',
    'qc.stats.zip',
  ],

  'Workflow activity: Assembly activity',
  ['Assembly', 'Fasta file containing the contigs from the assembly', 'sqm.01.fasta'],
  ['Assembly statistics', 'Length of the contigs', 'sqm.01.lon'],
  ['Assembly statistics', 'Assembly statistics (N50, N90, number of reads, etc)', 'sqm.01.stats'],
  [
    'Assembly Coverage BAM',
    'Sorted bam file of reads mapping back to the final assembly',
    'sqm.sorted.bam',
  ],

  'Workflow activity: Annotation activity',
  ['Annotation', 'Assignment (RDP classifier) for the 16S rRNAs sequences found', 'sqm.02.16S.txt'],
  [
    'Annotation',
    'Fasta file containing the contigs resulting from the assembly, masking the positions where a RNA was found',
    'sqm.02.maskedrna.fasta',
  ],
  ['Annotation', 'Fasta file containing all RNAs found', 'sqm.02.rnas'],
  ['Annotation', 'Text file containing contig and position of tRNAs found', 'sqm.02.trnas'],
  [
    'Annotation ',
    'Fasta file containing the contigs resulting from the assembly, masking the positions where a tRNA was found',
    'sqm.02.trnas.fasta',
  ],
  ['Annotation', 'Amino acid sequences for predicted ORFs', 'sqm.03.faa'],
  ['Annotation', 'Nucleotide sequences for predicted ORFs', 'sqm.03.fna'],
  ['Annotation', 'Features and position in contigs for each of the predicted genes', 'sqm.03.gff'],
  ['Annotation', 'Result of the homology search for COG', 'sqm.04.eggnog.diamond'],
  ['Annotation', 'Result of the homology search for KEGG', 'sqm.04.kegg.diamond'],
  ['Annotation', 'Result of the homology search for nr', 'sqm.04.nr.diamond'],
  ['Annotation', 'Results of the HMM search', 'sqm.05.pfam.hmm'],
  [
    'Annotation',
    'Taxonomic assignments not considering identity filters for each ORF, including taxonomic ranks ',
    'sqm.06.fun3.tax.noidfilter.wranks',
  ],
  [
    'Annotation',
    'Taxonomic assignments for each ORF, including taxonomic ranks',
    'sqm.06.fun3.tax.wranks',
  ],
  ['Annotation', 'COG functional assignment for each ORF', 'sqm.07.fun3.cog'],
  ['Annotation', 'KEGG functional assignment for each ORF', 'sqm.07.fun3.kegg'],
  ['Annotation', 'PFAM functional assignment for each ORF', 'sqm.07.fun3.pfam'],
  ['Annotation', 'Assignment of contigs based on ORFs annotations', 'sqm.09.contiglog'],
  [
    'Annotation',
    'Assignment of contigs based on ORFs annotations, including taxonomic ranks',
    'sqm.09.contiglog_allranks',
  ],
  [
    'Annotation',
    'Assignment of contigs based on ORFs annotations not considering identity filters , including taxonomic ranks',
    'sqm.09.contiglog_allranks.noidfilter',
  ],
  [
    'Annotation',
    'Assignment of contigs based on ORFs annotations not considering identity filters ',
    'sqm.09.contiglog.noidfilter',
  ],
  [
    'Annotation statistics',
    'Several measures regarding mapping of reads to ORFs',
    'sqm.10.contigcov',
  ],
  [
    'Annotation statistics ',
    'Several measures regarding mapping of reads to ORFs',
    'sqm.10.mapcount',
  ],
  ['Annotation statistics', 'Mapping percentage of reads to samples', 'sqm.10.mappingstat'],
  ['Annotation statistics', 'Abundance table of taxa', 'sqm.11.mcount'],
  [
    'Annotation statistics',
    'measurements of the abundance and distribution of each COG',
    'sqm.12.cog.funcover',
  ],
  ['Annotation statistics', 'KEGG function table for STAMP', 'sqm.12.cog.stamp'],
  [
    'Annotation statistics',
    'measurements of the abundance and distribution of each KEGG',
    'sqm.12.kegg.funcover',
  ],
  ['Annotation statistics', 'COG function table for STAMP', 'sqm.12.kegg.stamp'],
  ['Annotation statistics', 'Several measures regarding ORF characteristics', 'sqm.13.orftable'],
  ['Annotation statistics', 'Taxonomic assignment summary of bins', 'sqm.16.bintax'],
  ['Annotation statistics', 'Concatenated CheckM output for each bin', 'sqm.17.checkM'],
  ['Annotation statistics', 'Coverage and TPM values for each bin', 'sqm.18.bincov'],
  ['Annotation statistics', 'Compilation of all data for bins', 'sqm.18.bintable'],
  ['Annotation statistics', 'List of contigs and corresponding bins', 'sqm.18.contigsinbins'],
  ['Annotation statistics', 'Compilation of data for contigs', 'sqm.19.contigtable'],
  ['Annotation', 'Prediction of KEGG pathways in bins', 'sqm.20.kegg.pathways'],
  ['Annotation', 'Prediction of Metacyc pathways in bins', 'sqm.20.metacyc.pathways'],
  ['Annotation statistics', 'Several statistics regarding ORFs, contigs and bins', 'sqm.21.stats'],
  ['Analysis information', 'Methods used by Squeezemeta', 'sqm.logs.zip'],

  'Workflow Activity: ReadBased Analysis Activity',
  ['Annotation', 'Taxonomic and functional assignments for each read', 'sqmreads.out.allreads'],
  [
    'Annotation statistics',
    'Abundance of all COG functions for each read',
    'sqmreads.out.allreads.funcog',
  ],
  [
    'Annotation statistics',
    'Abundance of all KEGG functions for each read',
    'sqmreads.out.allreads.funkegg',
  ],
  ['Annotation statistics', 'Abundance of all taxa for each read', 'sqmreads.out.allreads.mcount'],
  [
    'Annotation statistics',
    'Summary of total reads and hits to nr for each read',
    'sqmreads.out.mappingstat',
  ],
  ['Analysis information', 'Methods used by Squeezemeta reads', 'sqmreads.out.methods.txt'],

  'Workflow Activity: MAGs Analysis Activity',
  ['Metagenome Bins', 'Metagenome bin contigs fasta', 'sqm.bins.zip'],

  'Workflow Activity: Supporting documentation',
  ['Checksum for Squeezemeta workflow', 'md5 checksum file', 'sqm.md5'],
  ['checksum for SQM reads - sampleID.md5', 'md5 checksum file', 'sqmreads.out.md5'],
]
